/* DGA nieuwe huisstijl: vloeiende FAQ (dga-faq) op de WS2.0-paginalaag.
   - er staat steeds een vraag open; klik je een nieuwe vraag aan, dan schuiven de andere netjes dicht
   - het antwoord schuift soepel uit de vraag naar beneden; het blauwe vlak van de vraag kleurt zacht in en uit
     (ook bij het dichtklappen, in plaats van pas aan het eind te verspringen)
   - bij hover wordt een (dichte) vraag blauw en vetgedrukt, zonder dat de tekst verspringt
   - het loepje in de zoekbalk is een echte knop: zoekt en scrolt naar de resultaten (ook met Enter)
   - de zoekbalk toont 'Stel je vraag, bijv:' met voorbeeldwoorden die getypt in beeld komen;
     klik je in het veld, dan verdwijnt de tekst en kun je direct typen
   - bij 'beweging verminderen' klapt alles direct open en dicht en staat de voorbeeldtekst stil
   Wordt alleen geladen op de templates in dga_pg (snippets/meta-tags.liquid). */
(function(){
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isDe=/^\/de(\/|$)/.test(location.pathname);
  var DUR=320;

  /* Overgangen voor de vraagregel. De vraag heeft altijd dezelfde marge en padding (open of dicht), zodat bij
     openen alleen de kleur verandert en er niets verspringt. 'Vet' bij hover via een dunne tekstrand, zodat de
     regel niet breder wordt. */
  if(!document.getElementById('pg-faq-style')){
    var st=document.createElement('style');st.id='pg-faq-style';
    st.textContent=
      'html:not(#a):not(#b) .dga-faq__item>.dga-faq__summary{margin-left:-20px!important;margin-right:-20px!important;padding-left:20px!important;padding-right:20px!important;transition:background-color .45s ease,color .3s ease!important}'+
      'html:not(#a):not(#b) .dga-faq__item>.dga-faq__summary *{transition:color .3s ease,-webkit-text-stroke-color .3s ease}'+
      'html:not(#a):not(#b) .dga-faq__item:not([open])>.dga-faq__summary:is(:hover,:focus-visible){color:#0060D8!important;-webkit-text-stroke:.45px currentColor}'+
      'html:not(#a):not(#b) .dga-faq__item:not([open])>.dga-faq__summary:is(:hover,:focus-visible) *{color:#0060D8!important}'+
      'html:not(#a):not(#b) .dga-faq__item[open].pg-closing>.dga-faq__summary{background:transparent!important;color:#000!important}'+
      'html:not(#a):not(#b) .dga-faq__item[open].pg-closing>.dga-faq__summary *{color:#000!important}'+
      'html:not(#a):not(#b) .dga-faq__item[open].pg-closing .dga-faq__ico :is(svg,path){fill:currentColor!important;color:#000!important}'+
      '@media (prefers-reduced-motion:reduce){html:not(#a):not(#b) .dga-faq__item>.dga-faq__summary,html:not(#a):not(#b) .dga-faq__item>.dga-faq__summary *{transition:none!important}}';
    document.head.appendChild(st);
  }

  function animate(el,from,to,done){
    el.style.overflow='hidden';el.style.height=from+'px';
    void el.offsetHeight;
    el.style.transition='height '+DUR+'ms cubic-bezier(.2,.7,.2,1)';
    el.style.height=to+'px';
    var finished=false;
    function end(e){
      if(finished||(e&&e.target!==el))return;finished=true;
      el.removeEventListener('transitionend',end);
      el.style.transition='';el.style.height='';el.style.overflow='';
      if(done)done();
    }
    el.addEventListener('transitionend',end);setTimeout(end,DUR+80);
  }
  function closeItem(d){
    if(reduce){d.open=false;return;}
    var s=d.querySelector('summary');
    d.classList.add('pg-busy','pg-closing');
    animate(d,d.offsetHeight,s?s.offsetHeight+(d.offsetHeight-d.clientHeight):0,function(){d.open=false;d.classList.remove('pg-busy','pg-closing');});
  }
  function openItem(d){
    if(reduce){d.open=true;return;}
    var start=d.offsetHeight;
    d.open=true;
    var a=d.querySelector('.dga-faq__a');
    if(a){a.classList.remove('pg-in');void a.offsetWidth;a.classList.add('pg-in');}
    var end=d.offsetHeight;
    d.classList.add('pg-busy');
    animate(d,start,end,function(){
      d.classList.remove('pg-busy');
      /* Valt de vraag door het dichtschuiven van een vraag erboven buiten beeld, dan rustig terugscrollen */
      var s=d.querySelector('summary'),r=s&&s.getBoundingClientRect();
      if(r&&r.top<90){window.scrollBy({top:r.top-110,behavior:'smooth'});}
    });
  }
  document.addEventListener('click',function(e){
    var s=e.target.closest&&e.target.closest('.dga-faq__summary');if(!s)return;
    var d=s.parentElement;if(!d||d.tagName!=='DETAILS'||!d.classList.contains('dga-faq__item'))return;
    e.preventDefault();
    if(d.classList.contains('pg-busy'))return;
    if(d.open){closeItem(d);return;}
    var scope=d.closest('[id^="dga-faq-"]')||document;
    [].forEach.call(scope.querySelectorAll('details.dga-faq__item[open]'),function(o){if(o!==d)closeItem(o);});
    openItem(d);
  },true);

  /* Getypte voorbeeldvragen in de zoekbalk */
  var PREFIX=isDe?'Stell deine Frage, z. B.: ':'Stel je vraag, bijv: ';
  var WORDS=isDe?['Leasing','Garantie','Outdoor','Preise','Snackautomat','Lynova']:['lease','garantie','outdoor','prijzen','snackautomaat','Lynova'];
  function typewriter(input){
    if(!input.getAttribute('aria-label'))input.setAttribute('aria-label',isDe?'Durchsuche die h\u00e4ufig gestellten Fragen':'Zoek in de veelgestelde vragen');
    if(reduce){input.placeholder=PREFIX+WORDS.slice(0,3).join(', ')+' \u2026';return;}
    var w=0,c=0,phase='type',timer=null,running=false,visible=true;
    function render(cursor){input.placeholder=PREFIX+WORDS[w].slice(0,c)+(cursor?'|':'');}
    function step(){
      if(!running)return;
      var word=WORDS[w],delay=85;
      if(phase==='type'){c++;render(true);if(c>=word.length){phase='hold';delay=1500;}}
      else if(phase==='hold'){render(false);phase='erase';delay=250;}
      else if(phase==='erase'){c--;render(true);delay=40;if(c<=0){phase='next';delay=350;}}
      else{w=(w+1)%WORDS.length;c=0;phase='type';render(true);delay=120;}
      timer=setTimeout(step,delay);
    }
    function start(){if(running||document.activeElement===input||input.value||!visible||document.hidden)return;running=true;render(true);timer=setTimeout(step,300);}
    function stop(){running=false;clearTimeout(timer);}
    input.addEventListener('focus',function(){stop();input.placeholder='';});
    input.addEventListener('blur',function(){if(!input.value){c=0;phase='type';start();}});
    document.addEventListener('visibilitychange',function(){if(document.hidden)stop();else start();});
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(entries){entries.forEach(function(en){visible=en.isIntersecting;if(visible)start();else stop();});}).observe(input);
    }
    start();
  }

  /* Loepje als echte zoekknop */
  function initSearch(){
    [].forEach.call(document.querySelectorAll('.dga-faq__search'),function(box){
      var input=box.querySelector('input');if(!input)return;
      if(!box.dataset.pgType){box.dataset.pgType='1';typewriter(input);}
      if(box.querySelector('.pg-faq-go'))return;
      var svg=null;[].forEach.call(box.children,function(k){if(k.tagName.toLowerCase()==='svg')svg=k;});
      var b=document.createElement('button');b.type='button';b.className='pg-faq-go';
      b.setAttribute('aria-label',isDe?'Suchen':'Zoeken');
      if(svg){svg.setAttribute('aria-hidden','true');b.appendChild(svg);}
      box.appendChild(b);
      b.addEventListener('click',function(){
        input.focus();
        input.dispatchEvent(new Event('input',{bubbles:true}));
        var sec=box.closest('[id^="dga-faq-"]');
        var list=sec&&(sec.querySelector('.dga-faq__chips')||sec.querySelector('.dga-faq__group'));
        if(input.value.trim()&&list){
          var top=list.getBoundingClientRect().top+window.pageYOffset-110;
          window.scrollTo({top:top,behavior:reduce?'auto':'smooth'});
        }
      });
      input.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();b.click();}});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initSearch);else initSearch();
})();
